import { render, staticRenderFns } from "./FeaturedDialog.vue?vue&type=template&id=1fb8b48d&scoped=true&"
import script from "./FeaturedDialog.vue?vue&type=script&lang=js&"
export * from "./FeaturedDialog.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedDialog.vue?vue&type=style&index=0&id=1fb8b48d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb8b48d",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
